import memoize from 'lodash/memoize';
import { createSelector } from 'reselect';

const emptyArray = [];

const getCollectionEntities = ({ entities: { collections } }) => collections;
const getCategoryEntities = ({ entities: { collectionCategories } }) => collectionCategories;
const getAttributeEntities = ({ entities: { collectionAttributes } }) => collectionAttributes;
const getEntryEntities = ({ entities: { collectionEntries } }) => collectionEntries;

const resolve = (ids, entities) => (ids ?? emptyArray).map((id) => entities?.[id]).filter(Boolean);

const getCollectionSelector = createSelector(
  [getCollectionEntities],
  (entities) => memoize((id) => entities?.[id]),
);

const getAllCollectionIds = ({ collections: { allCollections } }) => allCollections;
const getEntryIdsByCollection = ({ collections: { entriesByCollection } }) => entriesByCollection;
const getCollectionsByPage = ({ collections: { collectionsByPage } }) => collectionsByPage;

const getCollections = createSelector(
  [getAllCollectionIds, getCollectionSelector],
  (ids, getCollection) => ids.map(getCollection).filter(Boolean),
);

// Categories and attributes arrive with the collection, so they are resolved
// off its own id lists rather than fetched separately.
const getCollectionCategoriesSelector = createSelector(
  [getCollectionSelector, getCategoryEntities],
  (getCollection, entities) => memoize((id) => resolve(getCollection(id)?.categories, entities)),
);

const getCollectionAttributesSelector = createSelector(
  [getCollectionSelector, getAttributeEntities],
  (getCollection, entities) => memoize((id) => resolve(getCollection(id)?.attributes, entities)),
);

const getCollectionEntriesSelector = createSelector(
  [getEntryIdsByCollection, getEntryEntities],
  (idsByCollection, entities) => memoize((id) => resolve(idsByCollection?.[id], entities)),
);

const getPageCollectionsSelector = createSelector(
  [getCollectionsByPage],
  (byPage) => memoize((pageId) => byPage?.[pageId] ?? emptyArray),
);

export default {
  getCollectionSelector,
  getCollections,
  getCollectionCategoriesSelector,
  getCollectionAttributesSelector,
  getCollectionEntriesSelector,
  getPageCollectionsSelector,
};
